module.exports = __webpack_public_path__ + "static/img/pencil.10f36bd0.png";